// Fecha AAAA-MM-DD en hora de Lima. No usar toISOString().slice(0,10): da la fecha en
// UTC, y desde las 7 p.m. de Lima ya es "manana" (formularios y filtros de "hoy" quedaban
// con el dia siguiente).
export function fechaLima(d: Date | string | number = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Lima', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(d));
}
